import gql from 'graphql-tag';

import client from '../graphqlAPI';


const DELETE_MAM_OBJECT = gql`
  mutation Post(
    $assetSlugName: String!, $fileExtension: String!) {
      deleteMamObject(assetSlugName: $assetSlugName, fileExtension: $fileExtension){
        filename
      }
    }
`;

const GET_OBJECTS_LIST = gql`
  {
    getMamObjectsList {
      assetSlugName
      isPublic
      url
      fileExtension
      type
      fileReadableName {
        en
      }
    }
  }
`;

const deleteMamObject = async ({
  assetSlugName, fileExtension,
}) => {
  try {
    const result = await client.mutate({
      mutation: DELETE_MAM_OBJECT,
      variables: {
        assetSlugName,
        fileExtension,
      },
      fetchPolicy: 'no-cache',
      refetchQueries: [{
        query: GET_OBJECTS_LIST,
      }],
    })
      .then(queryResult => queryResult)
      .catch((error) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${error}`);
        return null;
      });

    const { data: { deleteMamObject: deletedObject } } = result;
    if (deletedObject) {
      return deletedObject;
    }
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: deleteMamObject Error: ${error}`);
    return null;
  }
};

export default deleteMamObject;
